import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { ConfigDataApi } from "@/Modules/Models/Api/OnBoarding";
import type { ConfigData } from "@/Modules/Models/Domain/OnBoarding";
import type { Option } from "@/Components/UI/TcSelect.vue";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

export const ConfigReasonTransformer: TransformerExtended<ConfigData, ConfigDataApi, Option> = {
  ...DefaultTransformerGenerator<ConfigData, ConfigDataApi>(),

  toDomain(input) {
    return camel<ConfigDataApi, ConfigData>(input);
  },

  toUi(input: ConfigDataApi): Option {
    return {
      label: input.text,
      value: input.uuid ?? input.text,
      extraValue: input.extra,
    };
  },
};

export type ConfigReasonTransformerType = TransformerExtended<ConfigData, ConfigDataApi, Option>;

export default ConfigReasonTransformer;
